/**
 * Button Type constant for use with Button component.
 * @exportedComponentConstant
 */
var ButtonType;
/**
 * IconButton Type constant for use with IconButton component.
 * @exportedComponentConstant
 */

(function (ButtonType) {
  ButtonType["Primary"] = "BUTTON/PRIMARY";
  ButtonType["Secondary"] = "BUTTON/SECONDARY";
  ButtonType["Tertiary"] = "BUTTON/TERTIARY";
  ButtonType["Full"] = "BUTTON/FULL";
  ButtonType["FlatPrimary"] = "BUTTON/FLAT_PRIMARY";
  ButtonType["FlatSecondary"] = "BUTTON/FLAT_SECONDARY";
  ButtonType["Plain"] = "BUTTON/PLAIN";
  ButtonType["Destructive"] = "BUTTON/DESTRUCTIVE";
  ButtonType["Link"] = "BUTTON/LINK";
  ButtonType["PrimaryPill"] = "BUTTON/PRIMARY_PILL";
  ButtonType["SecondaryPill"] = "BUTTON/SECONDARY_PILL";
  ButtonType["TertiaryPill"] = "BUTTON/TERTIARY_PILL";
})(ButtonType || (ButtonType = {}));

var IconButtonType;
/**
 * Button Size constant for use with Button component.
 * @exportedComponentConstant
 */

(function (IconButtonType) {
  IconButtonType["Primary"] = "BUTTON/PRIMARY";
  IconButtonType["Secondary"] = "BUTTON/SECONDARY";
  IconButtonType["Tertiary"] = "BUTTON/TERTIARY";
  IconButtonType["Full"] = "BUTTON/FULL";
  IconButtonType["FlatPrimary"] = "BUTTON/FLAT_PRIMARY";
  IconButtonType["FlatSecondary"] = "BUTTON/FLAT_SECONDARY";
  IconButtonType["Plain"] = "BUTTON/PLAIN";
  IconButtonType["Destructive"] = "BUTTON/DESTRUCTIVE";
  IconButtonType["PrimaryPill"] = "BUTTON/PRIMARY_PILL";
  IconButtonType["SecondaryPill"] = "BUTTON/SECONDARY_PILL";
  IconButtonType["TertiaryPill"] = "BUTTON/TERTIARY_PILL";
})(IconButtonType || (IconButtonType = {}));

var ButtonSize;
/**
 * Button State constant for use with Button component.
 * @exportedComponentConstant
 */

(function (ButtonSize) {
  ButtonSize[ButtonSize["Small"] = 12] = "Small";
  ButtonSize[ButtonSize["Medium"] = 16] = "Medium";
  ButtonSize[ButtonSize["Large"] = 24] = "Large";
  ButtonSize[ButtonSize["XLarge"] = 32] = "XLarge";
})(ButtonSize || (ButtonSize = {}));

var ButtonState;
/**
 * Button Padding constant for use with Button component.
 * @exportedComponentConstant
 */

(function (ButtonState) {
  ButtonState["Default"] = "BUTTON/DEFAULT";
  ButtonState["Loading"] = "BUTTON/LOADING";
  ButtonState["Success"] = "BUTTON/SUCCESS";
  ButtonState["Error"] = "BUTTON/ERROR";
})(ButtonState || (ButtonState = {}));

var ButtonPadding;
/**
 * IconButton Size constant for use with IconButton component.
 *
 * @exportedComponentConstant
 *
 */
//IconButtonSize, IconButtonState and IconPadding are the same as the respective Button enums.
//Breaking them into their own 1) so they are decoupled for future flexibility, and 2) for developer convenience.
//Should be easier for a dev to keep their mental model in the same namespace.

(function (ButtonPadding) {
  ButtonPadding["None"] = "BUTTON/PADDING/NONE";
  ButtonPadding["Default"] = "BUTTON/PADDING/DEFAULT";
  ButtonPadding["Wide"] = "BUTTON/PADDING/WIDE";
})(ButtonPadding || (ButtonPadding = {}));

var IconButtonSize;
/**
 * IconButton State constant for use with IconButton component.
 * @exportedComponentConstant
 */

(function (IconButtonSize) {
  IconButtonSize[IconButtonSize["Small"] = 12] = "Small";
  IconButtonSize[IconButtonSize["Medium"] = 16] = "Medium";
  IconButtonSize[IconButtonSize["Large"] = 24] = "Large";
  IconButtonSize[IconButtonSize["XLarge"] = 32] = "XLarge";
})(IconButtonSize || (IconButtonSize = {}));

var IconButtonState;
/**
 * IconButton State constant for use with IconButton component.
 * @exportedComponentConstant
 */

(function (IconButtonState) {
  IconButtonState["Default"] = "BUTTON/DEFAULT";
  IconButtonState["Loading"] = "BUTTON/LOADING";
  IconButtonState["Success"] = "BUTTON/SUCCESS";
  IconButtonState["Error"] = "BUTTON/ERROR";
})(IconButtonState || (IconButtonState = {}));

var IconButtonPadding;

(function (IconButtonPadding) {
  IconButtonPadding["None"] = "BUTTON/PADDING/NONE";
  IconButtonPadding["Default"] = "BUTTON/PADDING/DEFAULT";
  IconButtonPadding["Wide"] = "BUTTON/PADDING/WIDE";
})(IconButtonPadding || (IconButtonPadding = {}));

export { ButtonPadding, ButtonSize, ButtonState, ButtonType, IconButtonPadding, IconButtonSize, IconButtonState, IconButtonType };
